import LinkInternal from '../LinkInternal';
import Item from '../Item';

export default [
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'infoMAP',
				text: 'Informácie o aplikácii Mapka',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'howto',
				text: 'Ako pracovať s&nbsp;Mapkou',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'sources',
				text: 'Zdroje nárečových ukážok',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'explorators',
				text: 'Prehľad nárečových ukážok',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'howToAttribute',
				text: 'Ako citovať Mapku',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'kudosGoTo',
				text: 'Poďakovanie',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'media',
				text: 'Mapka v médiách',
			}),
		},
	},
	{
		component: Item,
		props: {
			render: new LinkInternal({
				id: 'contact',
				text: 'Kontakt',
			}),
		},
	},
];
